import clsx from "clsx";
import React from "react";
import "./faTableBody.scss";

interface FaTableBodyProps extends React.ComponentPropsWithoutRef<"div"> { }

export function FaTableBody(props: FaTableBodyProps) {
    return <div {...props} className={clsx("fa-table-body", props.className)} />;
}
